import { render, staticRenderFns } from "./personUser.vue?vue&type=template&id=770e6abb&scoped=true"
import script from "./personUser.vue?vue&type=script&lang=js"
export * from "./personUser.vue?vue&type=script&lang=js"
import style0 from "./personUser.vue?vue&type=style&index=0&id=770e6abb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e6abb",
  null
  
)

export default component.exports